import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Sidebar } from "./Sidebar";
import { PeersheepLoader } from "@/components/ui/square-loader";

export function AppLayout() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <PeersheepLoader size="lg" label="Loading workspace" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar />
      <div className="flex flex-col flex-1 overflow-hidden">
        {/* pb-16 on mobile reserves space above the bottom tab bar */}
        <main className="flex-1 overflow-y-auto bg-background pb-16 md:pb-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
